import { styled } from "@mui/material/styles";

const StyledImageCroper = styled("div")(
  ({ theme }) => `
  .cropper-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
  
  }
    .cropper-btn {
      width: 100%;
      display: flex;
      align-tems: cneter;
      gap: 20px;
      justify-content: center;
    
    }

  .crop-btn {
    font-family: Lexend;
    width: 100px;
    padding: 10px 20px;
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.customColor.white};
    text-transform: none;
  }
  .cancel-btn {
    ont-family: Lexend;
    width: 100px;
    padding: 10px 20px;
    text-transform: none;
  }             
`
);

export default StyledImageCroper;
